import BaseAPI from '../BaseAPI'

export default class TimeZoneAPI extends BaseAPI {
  constructor () {
    super()
    this._resource = 'timezones'
  }
}
